import type {
  HistoryServiceV2,
  HistoryServiceV3,
} from '@feature-hub/history-service';
import {
  IconLink,
  type IconLinkProps,
  TextLink,
  type TextLinkProps,
} from '@smart/web-components';
import React from 'react';

interface SPAProps {
  historyService: HistoryServiceV2 | HistoryServiceV3;
}

interface SPATextLinkProps extends SPAProps, TextLinkProps {}
interface SPAIconLinkProps extends SPAProps, IconLinkProps {}

const convertToSPAnavigation =
  (
    path: string,
    callback?: React.MouseEventHandler<HTMLAnchorElement>,
    historyService?: HistoryServiceV2 | HistoryServiceV3,
  ) =>
  (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    callback?.(e);
    historyService?.rootHistory.push({pathname: path});
  };

export const SPATextLink = ({
  historyService,
  href,
  onClick,
  ...props
}: SPATextLinkProps) => {
  return (
    <TextLink
      href={href}
      onClick={convertToSPAnavigation(href, onClick, historyService)}
      {...props}
    />
  );
};

export const SPAIconLink = ({
  historyService,
  href,
  onClick,
  ...props
}: SPAIconLinkProps) => {
  return (
    <IconLink
      href={href}
      onClick={convertToSPAnavigation(href, onClick, historyService)}
      {...props}
    />
  );
};
